import React, { useState } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, TextField } from '@mui/material'
import { updateInstallation } from '../api/installation.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { refreshApiView } from '@e3dc-react/shell/State/ApiView/ApiViewActions'
import { useDispatch } from 'react-redux'

export interface RenameInstallationModalProps {
  onClose?: () => void
  place?: number
  name: string
  installationId: number
}

/**
 * This component is a modal in which we can set name/rename installation
 */

const RenameInstallationModal: React.FC<RenameInstallationModalProps> = props => {
  const { onClose, name, installationId } = props

  const { t } = useCustomTranslation()
  const [currentName, setCurrentName] = useState<string>(name || '')

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setCurrentName(event.target.value)
  }

  const authFetch = useAuthFetchWithResponse()
  const dispatch = useDispatch()

  const handleSaveClick = (): void => {
    updateInstallation(installationId, { partnersInstallationName: currentName }, authFetch)
    dispatch(refreshApiView())

    if (onClose) {
      onClose()
    }
  }

  const modalActions = {
    primary: {
      name: t('common.save'),
      onClick: handleSaveClick,
    },
    secondary: { name: t('common.cancel') },
  }

  return (
    <Dialog title={t('installation.renameModal.title')} onClose={onClose} actions={modalActions} maxWidth="sm">
      <Box sx={{ paddingTop: '20px' }}>
        <TextField
          fullWidth
          variant={'outlined'}
          label={t('common.name')}
          value={currentName}
          onChange={onChangeHandler}
          inputProps={{ maxLength: 50 }}
        />
      </Box>
    </Dialog>
  )
}

export default RenameInstallationModal
